<template>
  <v-alert
    text
    dense
    outlined
    color="deep-orange"
    icon="mdi-alert"
    max-width="768"
    style="margin: 5px auto"
  >
    <slot></slot>
  </v-alert>
</template>

<script>
export default {
  name: 'ErrorMessage'
}
</script>

<style scoped>

</style>
